<!-- 商业信息管理 -->
<script setup>
import i18n from "@/i18n"
import countryListData from '@/utils/country.js';
import CountryFlag from 'vue-country-flag-next'
// import flatPickr from "vue-flatpickr-component";
import { onMounted, reactive, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import tableCom from "./components/table.vue"
import { company_type_list } from "@/service/index"
import { getLangValue, switch_company_type_list_to_language_config } from "@/utils/common"; //获取后端语言
// import examineCom from "./components/examine.vue"
const PageHeaderT = getLangValue("business-user", "title")
const PageHeaderItems = [
    {
        text: getLangValue("business-user", "title"),
        active: false,
    },
    {
        text: getLangValue("business-user", "subtitle11"),
        active: true,
    },
]
const router = useRouter()
const route = useRoute()
const countryList = ref(countryListData);
const countryList1 = ref(countryListData);
const companyTypeList = ref([])
const tabList = ref([
    { name: getLangValue("business-user", "tab1"), number: 0, id: 0, },
    { name: getLangValue("business-user", "tab2"), number: 0, id: 1, },
    { name: getLangValue("business-user", "tab3"), number: 0, id: 2, },
])
const tableRef = ref(null)
// const examineRef = ref(null)
const current_tab = ref(route.query.search_type || 0)
// const showIndex = ref(0) // 0-table 1-examine 2-detail 
const searchData = reactive({
    type: current_tab.value,
    keyword: '',
    date: null,
    company_type: '',
    company_register_address: '',
})
/**
 * 搜索部分
 */
const search = () => {
    // console.log(searchData);
    tableRef.value.searchInfo.type = searchData.type
    tableRef.value.searchInfo.keyword = searchData.keyword
    tableRef.value.searchInfo.date = searchData.date
    tableRef.value.searchInfo.company_type = searchData.company_type
    tableRef.value.searchInfo.company_register_address = searchData.company_register_address
}
const filterCountry = (query) => {
    // 筛选国家
    if (query) {
        countryList.value = countryList1.value.filter((item) => {
            if ((item.zh.toLowerCase()).includes(query.toLowerCase()) || (item.en.toLowerCase()).includes(query.toLowerCase())) {
                return true
            }
        })
    } else {
        countryList.value = [...countryList1.value] //val为空时，还原数组
    }
}
const handlerToggleTab = (i,) => {
    current_tab.value = i
    // 搜索数据 控制参数
    searchData.type = i
    search()
}

const reset = () => {
    searchData.keyword = ''
    searchData.date = null
    searchData.company_type = ''
    searchData.company_register_address = ''
    search()
}

const updateTabData = (data) => {
    // 设置tab数据
    // 假数据
    tabList.value[0].number = data.wait_review_total
}
const getCompany_type_list = async () => {
    const reps = await company_type_list()
    if (reps.code == 0) {
        companyTypeList.value =  switch_company_type_list_to_language_config(reps.payload)
    }
}

/***
 * 切换信息部分
 * 
 */
const viewTabData = (info) => {
    console.log(info);
    // showIndex.value = 1
    // examineRef.value.currendData = info
    // examineRef.value.currendData = 
    router.push({ path: 'business_information_management_examine', query: { id: info.id } })
}

onMounted(() => {
    getCompany_type_list();
})


</script>
<template>
    <Layout>
        <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
        <div class="bg-white my-scroll-bar" style="overflow-x: auto; height: calc(100vh - 160px);overflow-y: hidden; border-radius: 0.25rem;">
            <div class="p-4 d-flex justify-content-between align-items-center "
                style="box-shadow: none; font-size: 16px; font-weight: bold; color: #495057;height: 78px;">
                {{ getLangValue("business-user", "subtitle") }}
                <button style="opacity: 0;">
                    <i class="ri-add-fill me-1 align-bottom"></i>
                    {{ $t("base.add") }} 
                    <!-- 0.0  -->
                </button>
            </div>
            <div class="px-4 py-2 d-flex justify-content-between" style="border-top: 1px dashed #E9EBEC;">
                <div style="flex:1" class="d-flex ">
                    <div class="form-icon" style="width: 422px;">
                        <input clearable type="text" class="form-control form-control-icon" v-model="searchData.keyword"
                            :placeholder="getLangValue('business-user', 'search_placeholder')" />
                        <i class="ri-search-line"></i>
                    </div>
                    <!-- 日期 -->
                    <!-- <el-date-picker class="mx-2" v-model="searchData.date" type="date" value-format="YYYY-MM-DD"
                        style="width: 252px;" :placeholder="getLangValue('business-user', 'search_placeholder1')"
                        size="large" /> -->
                    <!-- mode: 'range', -->
                    <!-- <div style="position: relative;">
                        <flat-pickr style="width: 252px;" v-model="searchData.date"
                            :placeholder="getLangValue('business-user', 'search_placeholder1')"
                            :config="{ enableTime: false, dateFormat: 'Y-m-d', mode: 'range', }"
                            class="form-control mx-2"></flat-pickr>
                        <i @click="searchData.date = ''" class="ri-close-circle-fill cursor-pointer"
                            style="position: absolute; right: 16px; top: 10px;color: #435185;"
                            v-if="searchData.date != null && searchData.date.length > 0"></i>
                    </div> -->
                    <div class="w-10 mx-2" style="position: relative;" :title="getLangValue('business-user', 'registre_time')">
                        <el-date-picker style="height: 37.5px;" v-model="searchData.date" type="daterange"
                            range-separator="-" :start-placeholder="getLangValue('base.start_date')" :end-placeholder="getLangValue('base.end_date')" size="large"
                            value-format="YYYY-MM-DD" />
                    </div>
                    <!-- 企业类型 -->
                    <el-select v-model="searchData.company_type" style="width: 252px;height: 37.5px;"
                        :placeholder="getLangValue('business-user', 'search_placeholder2')" size="large" clearable>
                        <!-- <el-option label="生产商" value="生产商" />
                        <el-option label="代理商" value="代理商" />
                        <el-option label="其他组织" value="其他组织" /> -->
                        <el-option v-for="(item, key) in companyTypeList" :key="key" :label="item.name"
                            :value="item.id" />
                    </el-select>
                    <el-select class="mx-2" v-model="searchData.company_register_address" style="width: 252px;height: 37.5px;"
                        filterable :filter-method="filterCountry"
                        :placeholder="getLangValue('business-user', 'search_placeholder3')" size="large" clearable>
                        <el-option v-for="item1 in countryList" :key="item1.key" :label="i18n.global.locale == 'en'? item1.en : item1.zh" :value="item1.key">
                            <country-flag :country='item1.key' size='small' /> {{ i18n.global.locale == 'en'? item1.en :  item1.zh }}
                        </el-option>
                    </el-select>
                </div>
                <b-button variant="success" @click="search"
                    style="min-width: 100px; background-color: #405189;display: flex;align-items: center; border-color: unset; justify-content: center;">
                    <i class="ri-search-line me-1"></i>{{getLangValue('base.search') }}
                </b-button>
                <b-button class="mx-2" variant="success" @click="reset"
                    style="min-width: 100px;background-color: #299CDB;display: flex;align-items: center;border-color: unset; justify-content: center; ">
                    <i class="ri-refresh-line me-1"></i> {{ getLangValue('base.reset') }}
                </b-button>
            </div>
            <!-- tab搜索 -->
            <ul class="nav nav-tabs nav-tabs-custom nav-success d-flex align-items-center " role="tablist"
                style="border-bottom: 1px solid #E9EBEC; padding: 0;">
                <li class="nav-item" v-for="(tab, i) in tabList" :key="i" style="min-width: 115px; text-align: center;">
                    <a :class="[
                        'nav-link',
                        'All',
                        'position-relative cursor',
                        i == current_tab && 'active',
                    ]" @click="handlerToggleTab(i, tab.id)"
                        style="color: #405189; font-weight: 600; font-size: 13px;display: flex; align-items: center;">
                        {{ tab.name }}
                        <span class="badge bg-primary-subtle ms-1" v-if="tab.number > 0"
                            style="background-color: #F0654819; background-color: #F06548; padding: 4px 6px; border-radius: 4px;">{{
                                tab.number }}</span>
                    </a>

                </li>
            </ul>
            <tableCom ref="tableRef" @updateTabData="updateTabData" @viewTabData="viewTabData" />
        </div>
    </Layout>

</template>
<style lang="scss" scoped>

:deep(.el-select__placeholder.is-transparent) {
    font-size: 0.8125rem;
    color: #878a99 !important ;
}
:deep(.el-select__selected-item.el-select__placeholder) {
    font-size: 0.8125rem;
    color: #212529 ;
}
:deep(.el-date-editor .el-range-input) {
    font-size: 0.8125rem;
    color: #212529;
    &::placeholder {
        color: #878a99 !important;
    }
}
:deep(.el-select__wrapper) {
    height: 100%;
    min-height: unset;
}

</style>
<style>
.el-date-range-picker__header button {
    margin-top: 0 !important;
}
</style>